import { render } from "./SMSPackageDialog.vue?vue&type=template&id=4d5d4ee9&scoped=true&ts=true"
import script from "./SMSPackageDialog.vue?vue&type=script&lang=ts"
export * from "./SMSPackageDialog.vue?vue&type=script&lang=ts"

import "./SMSPackageDialog.vue?vue&type=style&index=0&id=4d5d4ee9&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5d4ee9"]])

export default __exports__